import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* bulkActivationsResponse({ payload: { data } }) {
  try {
    // const response = yield call(addData, "/API/V1/Activation/BulkActivation", data);
    const response = {
      "statusCode": 1400,
      "data": {
        "accountBalance": "199.87",
        "transactions": [
          {
            "remarks": "Request Refunded Successfully",
            "batchId": "",
            "transactionID": "UTLdca350d469f4488c",
            "activationID": 28,
            "paymentID": 0,
            "serialNumber": "8911111111111111113",
            "msisdn": null
          }
        ]
      },
      "message": "Activation failed. Reason: {\"resultCode\":{\"code\":\"106\",\"message\":\" The Sim was not found in the system. \",\"description\":\" The Sim was not found in the system. \",\"partnerTransactionId\":\"UTLdca350d469f4488c\"}}"
    }
    console.log("response==>>", response)
    if (response?.statusCode == 1200) {
      yield put(actions.createBulkActivationSuccess(response?.message));
    } else {
      yield put(actions.createBulkActivationFailed(response?.message, JSON.parse(response?.data)));
    }
  } catch (error) {
    yield put(actions.createBulkActivationFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.BULK_ACTIVATION, bulkActivationsResponse),]);
}
